import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-8 md:py-12 px-4 bg-brand-card scroll-mt-10" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        {/* Urgency Header */}
        <div className="text-center mb-8" data-id="element-189">
          <div className="inline-block bg-brand-accent/20 text-brand-accent font-bold px-4 py-1.5 rounded-full mb-4 border border-brand-accent/30 animate-pulse text-sm" data-id="element-190">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-4" data-id="element-191">
            <CountdownTimer data-id="element-192" />
          </div>

          <p className="text-sm md:text-base font-medium text-gray-400 mb-4" data-id="element-193">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="max-w-sm mx-auto bg-brand-dark p-3 rounded-lg border border-white/10" data-id="element-194">
            <div className="flex justify-between text-xs font-bold mb-1.5" data-id="element-195">
              <span className="flex items-center text-brand-accent" data-id="element-196">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-accent mr-1.5 animate-ping" data-id="element-197"></span>
                Cupos al precio de lanzamiento
              </span>
              <span className="text-gray-400" data-id="element-198">Quedan pocos</span>
            </div>
            <div className="w-full bg-gray-800 rounded-full h-2 mb-1 overflow-hidden" data-id="element-199">
              <div className="bg-brand-accent h-2 rounded-full w-[68%]" data-id="element-200"></div>
            </div>
            <p className="text-[10px] text-gray-600 text-right" data-id="element-201">
              68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-202">
          ELEGÍ TU KIT
        </h2>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-203">
          {/* Basic Kit */}
          <div className="bg-brand-dark rounded-xl border border-white/10 p-5 md:p-6 flex flex-col relative" data-id="element-204">
            <div className="mb-4" data-id="element-205">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-206">
                <span className="text-2xl mr-2" data-id="element-207">📘</span> KIT HISTORIA AGRARIA
                LISTA
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-208">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="bg-brand-card p-3 rounded-lg mb-6 border border-white/5" data-id="element-209">
              <p className="text-xs text-gray-400 font-medium" data-id="element-210">
                <span className="font-bold text-gray-200" data-id="element-211">Ideal para:</span>{' '}
                Docentes de Historia, Ciencias Sociales, Producción
                Agropecuaria, Orientación Agro y Ambiente
              </p>
            </div>

            <div className="mb-6 flex-grow" data-id="element-212">
              <div className="flex items-end justify-center mb-1" data-id="element-213">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-214">
                  $45.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-215">
                  $19.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-216">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47905319649518:1" className="py-3 text-sm md:text-base" pulse={false} data-id="element-217">
              → QUIERO MI KIT AHORA
            </Button>
          </div>

          {/* Premium Kit (Highlighted) */}
          <div className="bg-brand-dark rounded-xl border-2 border-brand-accent p-5 md:p-6 flex flex-col relative transform md:-translate-y-2 shadow-[0_0_20px_rgba(249,115,22,0.15)]" data-id="element-218">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-black px-4 py-1 rounded-full text-xs tracking-wider shadow-sm whitespace-nowrap" data-id="element-219">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-4 mt-2" data-id="element-220">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-221">
                <span className="text-2xl mr-2" data-id="element-222">🏆</span> KIT + CASOS REALES
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-223">
                6 Tomos + 4 Bonos + 15 Casos Reales del Agro Argentino
              </p>
            </div>

            <div className="bg-brand-accent/10 p-3 rounded-lg mb-6 border border-brand-accent/20" data-id="element-224">
              <p className="text-xs text-gray-300 font-medium" data-id="element-225">
                <span className="font-bold text-white" data-id="element-226">Ideal para:</span>{' '}
                Docentes que quieren trabajar con conflictos reales, debates en
                clase y estudios de caso aplicados
              </p>
            </div>

            <div className="mb-6 flex-grow" data-id="element-227">
              <div className="flex items-end justify-center mb-1" data-id="element-228">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-229">
                  $63.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-230">
                  $28.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-231">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47905346519278:1" className="py-3 md:py-4 text-base md:text-lg" pulse={true} data-id="element-232">
              → QUIERO EL KIT + CASOS REALES
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs md:text-sm text-gray-500 font-medium" data-id="element-233">
          <div className="flex items-center" data-id="element-234">
            <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-235" />
            <span data-id="element-236">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-237">
            <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-238" />
            <span data-id="element-239">Acceso en 5 min</span>
          </div>
          <div className="flex items-center" data-id="element-240">
            <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-241" />
            <span data-id="element-242">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-243">
            <CreditCard className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-244" />
            <span data-id="element-245">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}